module.exports = __webpack_public_path__ + "static/media/Valerie He.24a354d5.jpg";